import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { CmpsAuthModule } from '../auth/auth.module';

import { DebugPanelComponent } from './panel.debug.component';

@NgModule({
    imports: [CommonModule, CmpsAuthModule],
    declarations: [DebugPanelComponent],
    exports: [DebugPanelComponent],
})
export class CmpsDebugModule {}
